import { Icon, TextInput, TextInputProps } from "@oysterhr/ui"

import { forwardRef } from "react"
export const StandalonePercentageInput = forwardRef<HTMLInputElement, TextInputProps>(
  function StandalonePercentageInput(props, ref) {
    return (
      <TextInput
        ref={ref}
        endAdornment={<Icon name="Percent" className="text-gray-300" />}
        {...props}
      />
    )
  },
)
